export const OnlySourceOptions = [
  { label: '门店真实存在', value: 1, reportType: 1 },
  { label: '门店不存在', value: 6, reportType: 2 },
];

export const MaybeSameShopOptions = [
  { label: '门店重复', value: 15, reportType: 3 },
  { label: '门店不重复', value: 1, reportType: 4 },
];
